import { MenuItemsUseCase } from "constants/menu-items";
import { ROUTER_PATHS } from "constants/routes";
import useMenuItems from "hooks/useMenuItems";
import { useTheme } from "injectors/theme";
import SecondaryNavbar from "layouts/secondary-navbar-wrapper";
import { FC, useMemo } from "react";
import {
  selectFlatChecklistItems,
  selectOpenExtendedChecklistItems,
} from "store/dossier/selectors";
import { useSelector } from "store/helpers";
import SecondaryNavItem from "../secondary-nav-item";
import { useStyles } from "./styles";
import { ChecklistItemStatusType } from "@kolibrisoftware/customerportal-api";

type Props = {};

const SecondaryNavigation: FC<Props> = props => {
  const theme = useTheme();
  const styles = useStyles({ theme });
  const allChecklistItems = useSelector(selectFlatChecklistItems);
  const menuItems = useMenuItems(MenuItemsUseCase.DOSSIER);

  // We don't count parent checklist items in the notification count,
  // as they are not actionable by the user.
  const filteredChecklistItems = useMemo(
    () =>
      allChecklistItems?.filter(
        item =>
          item.status === ChecklistItemStatusType.Open &&
          item?.isParent !== true
      ),
    [allChecklistItems]
  );

  return (
    <SecondaryNavbar>
      <div className={styles.navItemsContainer}>
        {menuItems.map((item, index) => {
          if (item.path === ROUTER_PATHS.CHECKLIST) {
            return (
              <SecondaryNavItem
                item={item}
                notification={filteredChecklistItems?.length}
                key={`desktop-nav-item-${index}`}
                data-cy="ChecklistNavItem"
              />
            );
          }
          return (
            <SecondaryNavItem
              item={item}
              key={`desktop-nav-item-${index}`}
              data-cy="NavItem"
            />
          );
        })}
      </div>
    </SecondaryNavbar>
  );
};

export { SecondaryNavigation };
